import React, { Component } from 'react';
import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { connect } from 'react-redux';

import { isAdmin, isSupervisor} from '../../utils/roles';

import Categories from './Categories';

const { SubMenu } = Menu;
const { Content, Sider } = Layout;
const categories = Categories.categories;

class Dashboard extends Component {
  state = {
    breadcrumb: ['Quản lý', 'Bài viết'],
    selected: 'Posts',
  };

  onSelectItem = ({ key }) => {
    let breadcrumb;
    const temp = ['Quản lý'];
    categories.forEach(category => {
      temp.push(category.title);
      if (category.type === 'item' && category.key === key) {
        breadcrumb = [...temp];
      } else if (category.type === 'sub-menu') {
        category.items.forEach(item => {
          temp.push(item.title);
          if (item.key === key) {
            breadcrumb = [...temp];
          }
          temp.pop();
        });
      }
      temp.pop();
    });

    this.setState({
      breadcrumb,
      selected: key,
    });
  }

  handleChangeBreadCrumb = (type, item) => {
    const newBreadCrumb = [...this.state.breadcrumb];
    if (type === 'push') {
      newBreadCrumb.push(item);
      this.setState({ breadcrumb: newBreadCrumb });
    } else if (type === 'pop') {
      newBreadCrumb.pop();
      this.setState({ breadcrumb: newBreadCrumb });
    }
  }

  render() {

    const ContentComponent = Categories[this.state.selected];
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 18,
          offset: 5,
        },
      },
    };

    return (
      <Layout style={{ background: '#fff' }}>
        <Breadcrumb style={{ margin: '5px 0' }}>
          {this.state.breadcrumb.map(item => (<Breadcrumb.Item key={item}>{item}</Breadcrumb.Item>))}
        </Breadcrumb>
        <Layout style={{ padding: '24px 0', background: '#fff' }}>
          <Sider width={200} style={{ background: '#fff' }}>
            <Menu
              mode="inline"
              defaultSelectedKeys={['Posts']}
              defaultOpenKeys={['Management']}
              style={{ height: '100%' }}
              onSelect={this.onSelectItem}
            >
              {categories.map(category => {
                if ( isAdmin(this.props.role) || !category.adminOnly || (category.allowSupervisor && isSupervisor(this.props.role)) ) {
                  return category.type === 'item' ?
                    (<Menu.Item key={category.key}><Icon type={category.icon} theme="outlined" /><span>{category.title}</span></Menu.Item>) :
                    (<SubMenu key={category.key} title={<span><Icon type={category.icon} />{category.title}</span>}>
                      {category.items.map(item => {
                         if ( isAdmin(this.props.role) || !item.adminOnly || (item.allowSupervisor && isSupervisor(this.props.role)) ) {
                           return  (<Menu.Item key={item.key}><Icon type={item.icon} /><span>{item.title}</span></Menu.Item>)
                         }
                         return null;
                      })}
                    </SubMenu>);
                }
                return null;
              })}
            </Menu>
          </Sider>
          <Content style={{ padding: '0 24px', minHeight: 280 }} >
            <ContentComponent
              handleChangeBreadCrumb={this.handleChangeBreadCrumb}
              formItemLayout={formItemLayout}
              tailFormItemLayout={tailFormItemLayout}
            />
          </Content>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  role: state.user.info.role,
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.js